module.exports = __webpack_public_path__ + "src/assets/games/35/rabbit0088.jpg";